export const nl = {
    "ADD": "Toevoegen",
    "ADDRESS": "Adres",
    "ADMIN": "Beheer",
    "APPLICATION": "Programma",
    "CANCEL": "Annuleren",
    "CHANGE LANGUAGE": "Taal wijzigen",
    "CLOSE": "Sluiten",
    "CONFIRM": "Uitvoeren?",
    "CONFIRM WARNING": "Deze handeling kan niet ongedaan worden gemaakt",
    "CONTACT": "Contact",
    "CREATE": "Aanmaken",
    "CURRENT": "Huidige",
    "DATA": "Gegevens",
    "DATE": "Datum",
    "DELETE": "Verwijderen",
    "DELETE CONFIRM": "Weet u zeker dat u dit onderdeel wilt verwijderen",
    "DELETE CONFIRM MULTIPLE": "Weet u zeker dat u deze onderdelen wilt verwijderen",
    "DETAIL": "Detail",
    "DETAILS": "Details",
    "EDIT": "Bewerken",
    "EMAIL": "E-mail",
    "EMAIL ADDRESS": "E-mailadres",
    "EMAIL ERROR": "Er is geen geldige e-mail ingevoerd",
    "ERROR": "Fout",
    "FIELD":"Veld",
    "FIELD REQUIRED":"Dit veld is verplicht",
    "FORM INVALID": "Het formulier kan niet worden verstuurd. Vul eerst de ontbrekende velden in",
    "FORM SUCCESS": "De gegevens zijn opgeslagen",
    "LOGIN": "Inloggen",
    "LOGIN ERROR": "De ingevoerde email / wachtwoord combinatie is niet geldig",
    "LOGIN EXPIRED": "Uw autorisatie is verlopen. Log opnieuw in a.u.b",
    "LOGOUT": "Uitloggen",
    "NAME": "Naam",
    "PASSWORD": "Wachtwoord",
    "PASSWORD REQUIRED": "Er is geen wachtwoord ingevoerd",
    "PASSWORD ERROR": "Er is geen geldig wachtwoord ingevoerd",
    "PASSWORD MATCH ERROR": "De ingevoerde wachtwoorden komen niet overeen",
    "SUBMIT": "Indienen",
    "TITLE": "Titel",



};
